<template>
  <div class="nx-social-network-sending-editor">
    <nx-social-network-send-to-twitter
      v-model="twitter"
      v-bind="$attrs"
      :disabled="disabled"
    />
    <nx-social-network-send-to-facebook
      v-model="facebook"
      v-bind="$attrs"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import NxSocialNetworkSendToTwitter from '@/modules/social-network/sendings/Twitter';
import NxSocialNetworkSendToFacebook from '@/modules/social-network/sendings/Facebook';

export default {
  name: 'nx-social-network-sending-editor',
  extends: {},
  mixins: [],
  components: {
    NxSocialNetworkSendToFacebook,
    NxSocialNetworkSendToTwitter,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    twitter: {
      get() {
        return this.value.twitter || {};
      },
      set(value) {
        this.$emit('input', { ...this.value, ...{ twitter: value } });
      },
    },
    facebook: {
      get() {
        return this.value.facebook || {};
      },
      set(value) {
        this.$emit('input', { ...this.value, ...{ facebook: value } });
      },
    },
  },
};
</script>

<style lang="stylus">
.nx-social-network-sending-editor {
  .v-toolbar {
    &.bordered {
      border-width: 0 0 1px
      border-style: solid
      border-color: #bdbdbd !important
    }

    .v-btn .v-btn__content .v-icon {
      color: $button_fgColor
    }

    .v-toolbar__content {
      padding: 0
    }

    .v-toolbar__title {
      color: $toolbar_fgColor
      font-size: 14px
      text-transform: uppercase
      align-self: center
    }

    .switch {
      .v-input__control {
        padding-top: 50%
      }
    }

    .status {
      font-weight: normal
      color: #676775
    }
  }
}
</style>
